import type { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types'
import type { ManagedProject_Plain } from '@webamboos/admin'

export function useManagedProjects() {
  const { findOne } = useStrapi()
  const { localeProperties } = useI18n()

  const locale = computed(() => localeProperties.value.code as StrapiLocale)
  const managedProjects = useState<ManagedProject_Plain>(`managed-project_${locale.value}`)

  const fetch = async () => {
    const result = await findOne('managed-project', {
      locale: locale.value,
      populate: {
        hero: {
          populate: { action: true },
        },
        menu: {
          populate: {
            options: {
              poulate: '*',
            },
            startup_options: {
              populate: '*',
            },
          },
        },
        info: {
          populate: {
            info_cards: true,
            stats: true,
            action: true,
          },
        },
        single_testimonial: {
          populate: {
            team: {
              populate: {
                image: true,
              },
            },
          },
        },
        benefits_section: {
          populate: {
            benefits: true,
          },
        },
        tech: {
          populate: {
            technologies: {
              populate: ['image'],
            },
          },
        },
        how_we_work: {
          populate: {
            info_card: {
              populate: { video: true },
            },
          },
        },
        second_testimonial: {
          populate: {
            team: {
              populate: {
                image: true,
              },
            },
          },
        },
        testimonials: {
          populate: {
            partners: {
              populate: ['logo'],
            },
            testimonials: {
              populate: ['image', 'partner'],
            },
          },
        },
        faq: {
          populate: '*',
        },
        blog: {
          populate: {
            articles: {
              populate: {
                image: true,
              },
            },
          },
          sort: 'publishedAt:desc',
        },
        page_meta: {
          populate: {
            image: true,
          },
        },
        other_services: {
          populate: {
            service: {
              populate: {
                image: true,
              },
            },
          },
        },
      },
    })

    const attrs = result.data as unknown as ManagedProject_Plain
    managedProjects.value = attrs
  }

  return {
    fetch,
    managedProjects,
  }
}
